import React from 'react';
import _ from 'lodash';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

import ErrorMessage from './error-message';
import VoucherApplied from './voucher-applied';
import { isEmailAddressValid } from '@/utils/validator';

const { Order } = Mobi2Go;
const className = Mobi2Go.helpers.classNames;

class Voucher extends React.Component {
    constructor() {
        super();

        this.state = {
            voucher_code: Order.getVoucherCode(),
            voucher_applied: Order.getVoucherApplied(),
            voucher_error_message: Order.getVoucherErrorMessage(),
            reward: Order.getReward(),
            is_loading: false,
        };

        Order.bind({
            updateVoucherCode: voucher_code => this.setState({ voucher_code }),
            updateVoucherApplied: voucher_applied =>
                this.setState({ voucher_applied }),
            updateVoucherErrorMessage: voucher_error_message =>
                this.setState({ voucher_error_message }),
            updateReward: reward => this.setState({ reward }),
            syncSuccess: () => this.setState({ is_loading: false }),
        });

        this.debouncedStartLoaded = _.debounce(this.startLoading, 750);
    }

    onCodeChange = e => {
        const voucher_code = e.target.value;

        // Workaround whilst Chrome can't seem to compute the appropriate fields to autofill,
        // resulting in our voucher field being treated as an email and populated accordingly
        if (isEmailAddressValid(voucher_code)) {
            return;
        }

        Order.setVoucherCode(voucher_code);
    };

    onRemoveClick = () => {
        Order.setVoucherCode('');
    };

    onVoucherCodeInputKeydown = e => {
        const ENTER = 13;
        const TAB = 9;

        if (e.keyCode === ENTER || e.keyCode === TAB) {
            this.startLoading();
        } else {
            this.debouncedStartLoaded();
        }
    };

    startLoading = () => {
        if (this.state.voucher_code !== '') {
            Order.save();
            this.setState({ is_loading: true });
        }
    };

    render() {
        // An order can only have either a reward or a voucher
        if (this.state.reward) {
            return null;
        }
        const { t } = this.props;
        return (
            <div className="m2g-order-item m2g-order-voucher">
                {!this.state.voucher_applied && (
                    <div
                        data-icon-before
                        className="m2g-order-voucher-code-input-container m2g-input-container m2g-form-element--full-width"
                    >
                        <input
                            type="text"
                            autoComplete="off"
                            autoCapitalize="off"
                            spellCheck="false"
                            autoCorrect="off"
                            onChange={this.onCodeChange}
                            onKeyDown={this.onVoucherCodeInputKeydown}
                            value={this.state.voucher_code}
                            className="m2g-input m2g-order-voucher-code-input m2g-input m2g-form-element--full-width"
                            placeholder={t('enter_voucher_code')}
                        />
                        <span
                            className={className('m2g-icon', {
                                'm2g-icon--spinner': this.state.is_loading,
                                'm2g-icon--gift': !this.state.is_loading,
                            })}
                        />
                    </div>
                )}

                <VoucherApplied
                    voucher_applied={this.state.voucher_applied}
                    voucher_has_error={!!this.state.voucher_error_message}
                    onRemove={this.onRemoveClick}
                />

                <ErrorMessage
                    voucher_applied={!!this.state.voucher_applied}
                    voucher_error_message={this.state.voucher_error_message}
                />
            </div>
        );
    }
}

export default forwardRefWithTranslation('order.voucher')(Voucher);
